import { OrderType } from 'enums/modules/order/orderType';
import { useTranslation } from 'react-i18next';

const useOrderTypeText = (type: OrderType | null): string | null => {
  const { t } = useTranslation();

  const data = {
    [OrderType.Limit]: t('orderTypeLimit'),
    [OrderType.Market]: t('orderTypeMarket'),
    [OrderType.Stop]: t('orderTypeStop'),
    [OrderType.StopLimit]: t('orderTypeStopLimit'),
  };

  return type ? data[type] : null;
};

export default useOrderTypeText;
